@if ((showToolbar() | async)) {
  <ng-container class="mat-app-background">
    <mat-toolbar [color]="!getDarkModeValue() ? 'primary' : null" class="top-bar mat-elevation-z3">
      <button mat-icon-button aria-label="Side Nav Toggle" (click)="toggleSideNav()">
        <mat-icon>menu</mat-icon>
      </button>
      <img [src]="getLogoUrl() | async" width="45px" routerLink="/home" style="cursor: pointer"/>
      <span style="margin-left: 5px">InvFlow</span>
      <span class="navigation-spacer">
        @if (loggedInUsername$ | async) {
          <span style="font-weight: normal; font-size: 16px"
          >{{(loggedInUsername$ | async)}} - </span>
        }
        @if (organizationHandle$ | async) {
          <span style="font-weight: normal; font-size: 16px"
          >{{organizationHandle$ | async}}</span>
        }
      </span>
      <button mat-icon-button aria-label="Settings" routerLink="/settings">
        <mat-icon>settings</mat-icon>
      </button>
      <button mat-icon-button aria-label="Logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
      </button>
      <button mat-icon-button aria-label="Notifications Toggle" (click)="toggleNotificationNav()">
        <mat-icon>{{notificationNavOpened ? 'notifications_active' : 'notifications'}}</mat-icon>
      </button>
    </mat-toolbar>
    <mat-sidenav-container class="navigation-container">
      <mat-sidenav mode="side" [opened]="sideNavOpened" class="navigation-sidebar-container">
        <mat-progress-bar class="navigation-progress-loader"
          [mode]="navigationGroupsLoading ? 'indeterminate' : 'determinate'" value="0"
        color="primary"></mat-progress-bar>
        <mat-nav-list>
          @for (navigationGroup of getNavigationGroups(); track navigationGroup) {
            <div matSubheader>{{navigationGroup.name}}</div>
            @for (item of navigationGroup.items; track item) {
              <mat-list-item [routerLink]="item.route"
                routerLinkActive="is-active" class="list-item" #rla="routerLinkActive" [activated]="rla.isActive">
                <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
                <a matListItemTitle class="nav-item">{{item.name}}</a>
              </mat-list-item>
            }
            <mat-divider></mat-divider>
          }
          <div mat-subheader>Actions</div>
          <mat-list-item routerLink="/settings" routerLinkActive="is-active" #rla="routerLinkActive" [activated]="rla.isActive">
            <mat-icon matListItemIcon>settings</mat-icon>
            <a matListItemTitle>Settings</a>
          </mat-list-item>
          <mat-list-item (click)="logout()">
            <mat-icon matListItemIcon>logout</mat-icon>
            <a matListItemTitle>Logout</a>
          </mat-list-item>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav mode="over" position="end" [opened]="notificationNavOpened" class="navigation-notification-container">
        <h3>Notifications</h3>
        <mat-divider></mat-divider>
      </mat-sidenav>
      <mat-sidenav-content class="main-content-container">
        <ng-container *ngTemplateOutlet="router_outlet"></ng-container>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </ng-container>
} @else {
  <router-outlet>
  </router-outlet>
}

<ng-template #router_outlet>
  <router-outlet>
  </router-outlet>
</ng-template>
